import create from 'zustand';
import { persist } from 'zustand/middleware';

type RecentSearchState = {
  searches: Array<string>;
  limit: number;
};

type RecentSearchAction = {
  put: (keyword: string) => void;
  setLimit: (limit: number) => void;
};

export const useRecentSearch = create<RecentSearchState & RecentSearchAction>()(
  persist(
    (set, get) => ({
      searches: [],
      limit: 5,
      setLimit(limit) {
        set(() => ({ limit }));
      },
      put(keyword) {
        if (!keyword) return;
        const currentSearches = [...get().searches];
        if (!currentSearches.includes(keyword)) {
          if (currentSearches.length < get().limit) {
            currentSearches.unshift(keyword);
          } else {
            currentSearches.pop();
            currentSearches.unshift(keyword);
          }
        } else {
          const idx = currentSearches.indexOf(keyword);
          currentSearches.splice(idx, 1);
          currentSearches.unshift(keyword);
        }
        set(() => ({ searches: currentSearches }));
      },
    }),
    {
      name: 'recent-search',
      getStorage: () => localStorage,
    }
  )
);
